import { GridItem } from '@bnnvara/grids';
import React from 'react';

import TagList from '../components/TagList';

const ComposableTagList = (props) => (
  <GridItem
    columnStartSm="1"
    columnEndSm="span 12"
    columnStartMd="2"
    columnEndMd="span 10"
    columnStartLg="3"
    columnEndLg="11"
  >
    <TagList {...props} />
  </GridItem>
);

export default ComposableTagList;
